import { useState, useEffect, useMemo, useContext } from 'react';
import { useSelector } from 'react-redux';
import { getBlockTypesForDeviation } from '../../Moderation/redux/selectors';
import { BlockReasons } from '../../Moderation/redux/types';
import { DaEditorContext } from '../../Context/DaEditorContext';
import { getShowMatureContent } from '../../publicSession';
export function useDeviationMatureFilter(deviation) {
    var isCachedDeviation = useContext(DaEditorContext);
    var showMatureContentSetting = useSelector(function (state) {
        return getShowMatureContent(state);
    });
    var blockReasons = useSelector(function (state) {
        return getBlockTypesForDeviation(state, deviation, isCachedDeviation);
    });
    var _a = useState(false), matureFilterDisabled = _a[0], setMatureFilterDisabled = _a[1];
    // reset mature filter override when deviation changes
    useEffect(function () {
        setMatureFilterDisabled(false);
    }, [deviation.deviationId]);
    var hasNonOverridableBlockReasons = blockReasons.filter(function (reason) {
        return ![BlockReasons.MatureAge, BlockReasons.MatureFilter].includes(reason);
    }).length > 0;
    // When cached consider isBlocked to be true when mature is set off
    var isBlocked = deviation.isBlocked ||
        (isCachedDeviation && deviation.isMature && !showMatureContentSetting);
    var props = useMemo(function () { return ({
        showBlocked: isBlocked && (hasNonOverridableBlockReasons || !matureFilterDisabled),
        overrideMatureFilter: function () { return setMatureFilterDisabled(true); },
    }); }, [hasNonOverridableBlockReasons, matureFilterDisabled, isBlocked]);
    return props;
}
//# sourceMappingURL=useDeviationMatureFilter.js.map